import React from "react";
import "./about.css";
import { Fade } from "react-reveal";
import { RxDot } from "react-icons/rx";
import { usePortfolioData } from "../../hooks/usePortfolioData";

const About = () => {
  const { data, loading } = usePortfolioData();

  if (loading || !data) {
    return (
      <div className="about-container" id="about">
        <div>Loading...</div>
      </div>
    );
  }

  const { about } = data;
  const techCategories = [
    { title: "Frontend Core", items: about.technologies.frontendCore, startDelay: 400 },
    { title: "Frameworks & Libraries", items: about.technologies.frameworksLibraries, startDelay: 650 },
    { title: "Backend & Tools", items: about.technologies.backendTools, startDelay: 900 }
  ];

  return (
    <div className="about-container" id="about">
      <Fade delay={100}>
        <div className="section-header-text">
          <span className="section-header-num">01.</span>
          About Me
        </div>
      </Fade>

      <div className="about-section-content">
        <div className="about-section-text">
          {about.paragraphs.map((paragraph, index) => {
            const delay = 150 + (index * 50);
            const isLastParagraph = index === about.paragraphs.length - 1;
            
            return (
              <Fade key={index} delay={delay}>
                <div className="about-paragraph">
                  {isLastParagraph && paragraph.includes(about.currentCompany.name) ? (
                    <>
                      {paragraph.substring(0, paragraph.indexOf(about.currentCompany.name))}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={about.currentCompany.url}
                        className="accent"
                      >
                        {about.currentCompany.name}
                      </a>
                      {paragraph.substring(paragraph.indexOf(about.currentCompany.name) + about.currentCompany.name.length)}
                    </>
                  ) : (
                    paragraph
                  )}
                </div>
              </Fade>
            );
          })}
          
          <Fade delay={350}>
            <div className="about-paragraph">
              Here's a few technologies i work with:
            </div>
          </Fade>

          <div className="about-technology">
            {techCategories.map((category, catIndex) => (
              <div key={catIndex}>
                <h3>{category.title}</h3>
                <ul>
                  {category.items.map((tech, techIndex) => (
                    <Fade key={techIndex} delay={category.startDelay + (techIndex * 50)}>
                      <li>
                        <RxDot className="expIcon" />
                        {tech}
                      </li>
                    </Fade>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
